import { Box } from "@mui/material"
import type { ColumnDef } from "@tanstack/react-table"

import StyledChip from "@/components/common/Chip/Chip"
import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import type { ChangeLog } from "@/graphql/codegen/graphql"
import { CHANGE_LOG_CATEGORY_LABELS, CHANGE_LOG_SUB_CATEGORY_LABELS } from "@/screens/ChangeLog/constants"
import { statusesMap } from "@/screens/SystemAdmin/constants"
import { formatDate } from "@/utils/date"

export const useChangeLogColumns = (): ColumnDef<ChangeLog>[] => {
  return [
    {
      accessorKey: "category",
      header: "Category",
      enableSorting: true,
      size: 170,
      cell: ({ row }) => CHANGE_LOG_CATEGORY_LABELS[row.original.category],
    },
    {
      accessorKey: "subcategory",
      header: "Sub-Category",
      cell: ({ row }) => CHANGE_LOG_SUB_CATEGORY_LABELS[row.original.subcategory],
      enableSorting: true,
      size: 170,
    },
    {
      accessorKey: "record",
      header: "Record",
      enableSorting: true,
      size: 170,
    },
    {
      accessorKey: "message",
      header: "Changes",
      enableSorting: true,
      size: 240,
    },

    {
      accessorKey: "createdOn",
      size: 160,
      header: "Date Changes",
      cell: ({ row }) => {
        return (
          <StyledChip
            label={<span>{formatDate(row.original.createdOn)}</span>}
            classes={{
              colorDefault: "bg-gray-100",
            }}
            className='text-gray-900'
          />
        )
      },
      enableSorting: true,
    },
    {
      accessorKey: "userName",
      size: 170,
      header: "User Name",
      cell: ({ row }) => {
        const user = row.original.user
        return (
          <Box className='flex items-center justify-start gap-3 px-1'>
            <StatusIndicator status={Boolean(user?.isActive)} map={statusesMap} />
            <div>{user?.name}</div>
          </Box>
        )
      },
      enableSorting: true,
    },
  ]
}
